"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPagingQueryString = exports.convertFaultDetailsToImperial = exports.convertFaultDetailsToMetric = exports.findClosestKeyIndex = void 0;
var conversions_1 = require("@dtna/dvs-core-dcp-client-utils/lib/utils/conversions");
var faults_model_1 = require("../models/faults.model");
var paging_model_1 = require("../models/paging.model");
var findClosestKeyIndex = function (array, fieldName, target) {
    var minInd = 0;
    var maxInd = array && array.length - 1;
    while (maxInd - minInd > 1) {
        var ind = Math.round(minInd + (maxInd - minInd) / 2);
        if (target > array[ind][fieldName])
            minInd = ind;
        else
            maxInd = ind;
    }
    var distanceToUpper = array && array[maxInd][fieldName] - target;
    var index = array && (Math.min(target - array[minInd][fieldName], distanceToUpper) === distanceToUpper) ? maxInd : minInd;
    return index;
};
exports.findClosestKeyIndex = findClosestKeyIndex;
var convertFaultDetailsToMetric = function (faultDetails) { return (__assign(__assign({}, faultDetails), { odometer: Math.round((0, conversions_1.metersToKm)(faultDetails.odometer)) })); };
exports.convertFaultDetailsToMetric = convertFaultDetailsToMetric;
var convertFaultDetailsToImperial = function (faultDetails) { return (__assign(__assign({}, faultDetails), { odometer: Math.round((0, conversions_1.metersToMiles)(faultDetails.odometer)) })); };
exports.convertFaultDetailsToImperial = convertFaultDetailsToImperial;
var buildPagingQueryString = function (pagingData, rowKey) {
    var query = '&';
    var appendCriteria = function (criteria) {
        query += "".concat(criteria, "&");
        return query;
    };
    if (rowKey) {
        appendCriteria("offsetRowKey=".concat(rowKey));
    }
    if (pagingData.startDate) {
        var startDateMidNightTime = pagingData.startDate;
        startDateMidNightTime.set('hour', 0);
        startDateMidNightTime.set('second', 0);
        startDateMidNightTime.set('minute', 0);
        appendCriteria("startTimeStamp=".concat(startDateMidNightTime.valueOf()));
    }
    if (pagingData.endDate) {
        appendCriteria("endTimeStamp=".concat(pagingData.endDate.valueOf()));
    }
    if (!!pagingData.recordsToFetch && pagingData.recordsToFetch !== 0) {
        appendCriteria("recordCount=".concat(pagingData.recordsToFetch));
    }
    if (pagingData.filters) {
        var keys_1 = pagingData.filters;
        // Map of filter name from pagingData to query parameter name for simple pass-through filters
        var basicFilters = [
            'sourceAddress',
            'suspectParameterNumber',
            'failureModeIndicator',
            'serial',
            'title',
            'unitId',
            'sources',
        ];
        var detroitComponent_1 = 'detroit';
        var detroitComponentQueryString_1 = 'CTP,VTHU';
        // Use map to check all the basic filters and add them to the query string
        basicFilters.forEach(function (f) {
            if (!!keys_1[f] && !keys_1[f].includes('')) {
                if (detroitComponent_1.startsWith(keys_1[f].toString().toLowerCase())) {
                    appendCriteria("".concat(f, "=").concat(detroitComponentQueryString_1));
                    return;
                }
                appendCriteria("".concat(f, "=").concat(keys_1[f][0]));
            }
        });
        if (!!keys_1[paging_model_1.PagingMetadataFilterKey.IS_RESOLVED] && keys_1[paging_model_1.PagingMetadataFilterKey.IS_RESOLVED].includes('true')) {
            appendCriteria('resolved=true');
        }
        else {
            appendCriteria('resolved=false');
        }
        if (keys_1[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY]) {
            // Map of filter name from pagingData.Fc to query parameter name
            var faultTypesKey = 'faultTypes';
            var faultCodeFilters_1 = {
                SI: 'SI',
                SN: 'SN',
                SS: 'SS',
                SP: 'SP',
            };
            var selectedFaultCodes_1 = [];
            // Use map to check all the fault code filters and add them to the query string
            Object.keys(faultCodeFilters_1).forEach(function (f) {
                if (keys_1[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY].includes(f)) {
                    selectedFaultCodes_1.push(faultCodeFilters_1[f]);
                }
            });
            if (keys_1[paging_model_1.PagingMetadataFilterKey.FAULT_SEVERITY].length > 0) {
                appendCriteria("".concat(faultTypesKey, "=").concat(selectedFaultCodes_1.join(',')));
            }
        }
        var isBoxChecked_1 = keys_1[paging_model_1.PagingMetadataFilterKey.MORE_FILTERS];
        if (isBoxChecked_1) {
            var options = [
                {
                    key: 'flagged',
                    on: 'IS_FLAGGED',
                    off: 'IS_NOT_FLAGGED',
                },
                {
                    key: 'ringBuffer',
                    on: 'HAS_RING_BUFFER',
                    off: 'HAS_NO_RING_BUFFER',
                },
                {
                    key: 'geofence',
                    on: 'INSIDE_GEOFENCE',
                    off: 'OUTSIDE_GEOFENCE',
                },
                {
                    key: 'emailSent',
                    on: 'EMAIL_SENT',
                    off: 'EMAIL_NOT_SENT',
                },
            ];
            options.forEach(function (option) {
                var moreFaultFiltersKeyOn = option.on;
                var moreFaultFiltersKeyOff = option.off;
                var isOn = isBoxChecked_1.includes(faults_model_1.MoreFaultFiltersKey[moreFaultFiltersKeyOn]);
                var isOff = isBoxChecked_1.includes(faults_model_1.MoreFaultFiltersKey[moreFaultFiltersKeyOff]);
                if ((isOn) && (isOff)) {
                    // this will return all if both boxes are checked
                }
                else if (isOn) {
                    appendCriteria("".concat(option.key, "=true"));
                }
                else if (isOff) {
                    appendCriteria("".concat(option.key, "=false"));
                }
            });
        }
    }
    // Remove last '&' or '?' character
    return query.slice(0, -1);
};
exports.buildPagingQueryString = buildPagingQueryString;
